import { Users, GraduationCap, Clock } from 'lucide-react';
import { ConfigEntitySidePanel } from '../admin/config-entity-shared';
import type { Turma } from '../../types/models';

export function TurmaEditSidePanel({
  turma,
  turnoNome,
}: {
  turma?: Turma | null;
  turnoNome?: string;
}) {
  const alunos = turma?._count?.alunos ?? 0;
  const cap = turma?.capacidade ?? 0;

  return (
    <ConfigEntitySidePanel
      entity={turma ?? undefined}
      kpis={[
        { icon: <GraduationCap size={12} />, label: 'Ano letivo', value: turma?.anoLetivo ?? '—' },
        { icon: <Clock size={12} />, label: 'Turno', value: turnoNome || '—' },
        {
          icon: <Users size={12} />,
          label: 'Alunos',
          value: cap > 0 ? `${alunos}/${cap}` : String(alunos),
        },
      ]}
      hints={
        alunos > 0
          ? ['Turma com alunos matriculados — desativação preserva histórico.']
          : undefined
      }
    />
  );
}
